import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import GameCard from '@/components/entities/games/GameCard';
import GameSkeleton from '@/components/entities/games/GameCard/components/GameSkeleton';
import { useIsMobile } from '@/hooks/useIsMobile';
import { AppRoutes } from '@/i18n/constants';
import { gameQueryOptions } from '@/queries/games/games.queries';
import { SEARCH_QUERY_ALLOWED_CHARS_REGEX } from '../../../../consts/recentSearchRegex';

interface Props {
  recentSearch: string;
}

const ResentSearches = ({ recentSearch }: Props) => {
  const t = useTranslations('lobby.filters');
  const isMobile = useIsMobile();
  const normalized = recentSearch.trim();
  const isValid = normalized.length >= 3 && SEARCH_QUERY_ALLOWED_CHARS_REGEX.test(normalized);

  const { data, isLoading } = useQuery(gameQueryOptions.list({
    params: {
      page: 1,
      limit: isMobile ? 9 : 8,
      filters: { name: normalized.toLowerCase() },
    },
    options: {
      enabled: isValid,
    },
    scope: 'searchRecent',
  }));

  if (!isValid) {
    return null;
  }

  const games = data?.items ?? [];

  return (
    <div className="mb-6.5 lg:mb-4.25">
      <p className="text-white font-medium text-lg leading-5.5 lg:mb-2.75 mb-4.25">{t('recent-search')}</p>
      <div className="grid grid-cols-3 md:grid-cols-4  gap-1.75 lg:flex lg:flex-wrap lg:gap-4.25  md:gap-5 w-full">
        {isLoading
          ? Array.from({ length: 6 }).map((_, index) => (
              <GameSkeleton key={index} className="max-lg:p-0" />
            ))
          : games.map(game => (
              <GameCard
                likeButtonPosition={isMobile ? 'compact' : 'compactLg'} // TODO: might to change
                likeButtonIconSize="compactLg"
                key={game.id}
                id={game.id}
                name={game.name}
                cover={game.cover}
                path={AppRoutes.gamesId(game.id)}
                className="max-lg:p-0"
              />
            ))}
      </div>
    </div>
  );
};
export default ResentSearches;
